module.exports = __webpack_public_path__ + "static/media/info-circle.3807fdfa.svg";